import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '../../styles/variables';

const FooterContainer = styled.footer`
  background-color: ${colors.primary};
  color: ${colors.white};
  padding: 48px 24px 24px;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const FooterColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 48px;
  margin-bottom: 48px;
`;

const FooterColumn = styled.div``;

const FooterTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
  color: ${colors.white};
`;

const FooterLinks = styled.ul`
  list-style: none;
`;

const FooterLink = styled.li`
  margin-bottom: 12px;
  
  a {
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    transition: color 0.2s;
    
    &:hover {
      color: ${colors.white};
    }
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

const FooterLogo = styled(Link)`
  font-weight: 700;
  font-size: 20px;
  color: ${colors.white};
  text-decoration: none;
  
  span {
    color: ${colors.secondary};
  }
`;

const FooterCopyright = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
`;

const Footer = () => {
  return (
    <FooterContainer id="contact">
      <FooterContent>
        <FooterColumns>
          <FooterColumn>
            <FooterTitle>ElectroWave Club</FooterTitle>
            <FooterLinks>
              <FooterLink><Link to="/about">소개</Link></FooterLink>
              <FooterLink><Link to="/instructors">강사진 소개</Link></FooterLink>
              <FooterLink><Link to="/reviews">수강생 후기</Link></FooterLink>
              <FooterLink><Link to="/blog">블로그 (준비중)</Link></FooterLink>
            </FooterLinks>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>스터디 과정</FooterTitle>
            <FooterLinks>
              <FooterLink><Link to="/java">Java 기초</Link></FooterLink>
              <FooterLink><Link to="/java-advanced">Java 심화</Link></FooterLink>
              <FooterLink><Link to="/c">C 프로그래밍</Link></FooterLink>
              <FooterLink><Link to="/react">React 프론트엔드</Link></FooterLink>
              <FooterLink><Link to="/database">데이터베이스 모델링</Link></FooterLink>
              <FooterLink><Link to="/typescript">TypeScript</Link></FooterLink>
              <FooterLink><Link to="/ai-coding">AI 코딩</Link></FooterLink>
            </FooterLinks>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>고객 지원</FooterTitle>
            <FooterLinks>
              <FooterLink><Link to="/faq">자주 묻는 질문</Link></FooterLink>
              <FooterLink><Link to="/learning-guide">학습 가이드</Link></FooterLink>
              <FooterLink><Link to="/tuition">회비 안내</Link></FooterLink>
              <FooterLink><Link to="/refund-policy">환불 정책</Link></FooterLink>
              <FooterLink><Link to="/terms">이용약관</Link></FooterLink>
              <FooterLink><Link to="/privacy-policy">개인정보 처리방침</Link></FooterLink>
            </FooterLinks>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>문의하기</FooterTitle>
            <FooterLinks>
              <FooterLink><a href="mailto:firstman9@protonmail.com">firstman9@protonmail.com</a></FooterLink>
            </FooterLinks>
          </FooterColumn>
        </FooterColumns>
        
        <FooterBottom>
          <FooterLogo to="/">Electro<span>Wave</span> Club</FooterLogo>
          <FooterCopyright>© 2025 ElectroWave Club. All rights reserved.</FooterCopyright>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;